/** Módulo «Mantenedor de clientes» en rol_operacion (codgo_modulo). */
export const MANTENEDOR_CLIENTES_MODULO = 1;

/**
 * Operaciones de edición por sección (rol_operacion.operacion_codigo con módulo mantenedor clientes).
 * La consulta/visualización no usa estos códigos; solo la persistencia (Guardar) y el modo edición.
 */
export const OP_EDICION_DATOS_PERSONALES = 8;
export const OP_EDICION_DIRECCIONES = 9;
export const OP_EDICION_DATOS_COMERCIALES = 10;
export const OP_EDICION_DATOS_FINANCIEROS = 11;
